<template>
  <div class="swap-order-detail">
    <div class="row">
      <div class="label">分账组织</div>
      <div class="row-right">
        <el-cascader
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }"
          v-model="unitNo"
          clearable
          @change="getUnitCommodity"
        ></el-cascader>
      </div>
    </div>
    <div class="row">
      <div class="label">分账商品</div>
      <div class="row-right">
        <el-select class="fixed-width-100" v-model="commodityNo" @change="selectCommodity">
          <el-option
            v-for="(item,key) in commodityList"
            :key="item.number"
            :label="item.title"
            :value="item.number"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="main-title bbn" style="top: 115px" v-if="commodity.number">
      <p>商品信息</p>
    </div>
    <div class="main-body" style="top: 150px" v-if="commodity.number">
      <table class="table-custom">
        <thead>
        <tr>
          <th>商品编号</th>
          <th>商品名称</th>
          <th>商品类型</th>
          <th>商品规格</th>
          <th>商品库存</th>
          <th>商品单价</th>
          <th>押金</th>
          <th>价值</th>
          <th>有效时长</th>
          <th>商品状态</th>
          <th>所属组织</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ commodity.number }}</td>
          <td>{{ commodity.title }}</td>
          <td>{{ typeMap[commodity.type] }}</td>
          <td>{{ commodity.standard ? commodity.standard + 'V' : '' }}</td>
          <td>{{ commodity.stock ? commodity.stock : '无限制' }}</td>
          <td>{{ commodity.price }}</td>
          <td>{{ commodity.deposit }}</td>
          <td>{{ commodity.worth }}</td>
          <td>{{ commodity.duration ? commodity.duration / 86400000 + '天' : '' }}</td>
          <td>{{ statusMap[commodity.status] }}</td>
          <td>{{ commodity.unitName }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="main-title bbn" style="top:245px;display: flex;align-items: center;justify-content: space-between"
         v-if="commodity.number">
      <p>分账人信息</p>
      <el-button type="primary" @click="dialogVisible=true">{{ type == 'add' ? '新增' : '编辑' }}分账人</el-button>
    </div>
    <div class="main-body" style="top:280px" v-if="commodity.number">
      <table class="table-custom">
        <thead>
        <tr>
          <th>分账人组织</th>
          <th>分账人角色</th>
          <th>分账比例</th>
          <th>账户类型</th>
        </tr>
        </thead>
        <tbody v-if="accountList.length > 0">
        <tr v-for="(item,index) in accountList" :key="index">
          <td>{{ item.unitName }}</td>
          <td>{{ item.role }}</td>
          <td>{{ item.ratio }}%</td>
          <td>{{ accountTypeMap[item.accountType] }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="4">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="row" style="margin-left: 0;">
        <div class="normal-btn" @click="cancel">取消</div>
        <div class="blue-btn" @click="confirmEdit">确认{{ type == 'add' ? '新增' : '' }}</div>
      </div>
    </div>
    <el-dialog class="dialog" width="1120px" :visible.sync="dialogVisible">
      <div slot="title">
        <div style="font-size: 16px;font-weight: 500;">
          <span>{{ type == 'add' ? '新增' : '编辑' }}分账人</span>
          <i class="el-icon-circle-plus-outline icon" style="font-size: 24px;color: #67aa42" @click="addAccount"></i>
        </div>
      </div>
      <div class="modal">
        <div class="list" v-for="(item, index) in addAccountList" :key="index">
          <span style="font-weight: 600;">分账人{{ index + 1 }}：</span>
          <span class="name">分账人组织：</span>
          <el-cascader
            :ref="'tree' + index"
            :options="unitList"
            :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }"
            v-model="item.unit"
            clearable
            @change="getUnitName(index)"
          ></el-cascader>
          <span class="name">分账人角色：</span>
          <el-input style="width: 120px;" v-model="item.role"></el-input>
          <span class="name">分账比例：</span>
          <el-input style="width: 100px;" v-model="item.ratio">
            <template slot="suffix">%</template>
          </el-input>
          <span class="name">账户类型：</span>
          <el-select style="width: 140px;" v-model="item.accountType">
            <el-option label="企业支付宝账户" value="0"></el-option>
            <el-option label="二级进件账户" value="1"></el-option>
            <el-option label="支付宝登录账户" value="2"></el-option>
          </el-select>
          <i class="el-icon-remove icon" style="font-size: 24px;color:red;" @click="deleteAccount(index)"></i>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmAccount">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'subAccountDetailView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      unitList: [],
      unitNo: [],
      commodityList: [],
      commodityNo: '',
      commodity: {},
      statusMap: {
        '1': '在售',
        '2': '停售'
      },
      typeMap: {
        '1': '直流充电服务',
        '2': '换电服务',
        '3': '交流充电服务',
        '4': '换电卡',
        '5': '充电卡',
        '6': '电池',
        '7': '电池适配器',
        '8': '充电柜充电服务',
        '9': '电动车',
        '10': '租车卡'
      },
      accountList: [],
      dialogVisible: false,
      type: 'add',
      addAccountList: [],
      tempCommodityNo: '',
      accountTypeMap: {
        '0': '企业支付宝账户',
        '1': '二级进件账户',
        '2': '支付宝登录账户'
      }
    }
  },
  watch: {
    editData: {
      handler() {
        this.unitNo = this.editData.unitNo.split("[")[1].split("]")[0].split(",");
        this.tempCommodityNo = this.editData.commodityNo;
        this.getUnitCommodity();
      },
      deep: true,
    },
  },
  mounted() {
    this.type = this.$parent.view;
    this.getUnitMember();
  },
  methods: {
    getAccountList() {
      let self = this;
      let params = {
        commodityNo: this.commodityNo
      }
      this.$http
        .post("/managementPlatform/fund/findDistributeRelation", this.$qs.stringify(params))
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          let list = [];
          res.ldata.forEach(v => {
            let item = {};
            item.unit = v.relationUnitNo.split("[")[1].split("]")[0].split(",");
            item.role = v.role;
            item.ratio = v.ratio;
            item.accountType = v.accountType;
            item.unitName = v.relationUnitName;
            list.push(item);
          })
          self.accountList = JSON.parse(JSON.stringify(list));
          self.addAccountList = JSON.parse(JSON.stringify(list));
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    getUnitMember() {
      let self = this;
      let params = {
        authorityType: 231
      }
      this.$http
        .post("/managementPlatform/unit/queryManagedUnit", this.$qs.stringify(params))
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.unitList = res.mdata.unitTree;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    getUnitCommodity() {
      let self = this;
      let params = {
        unitNo: this.unitNo[this.unitNo.length - 1],
        beginIndex: 0,
        pageSize: 999
      };
      this.$http.post('/managementPlatform/admin/queryCommodity', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.commodityList = res.ldata;
        if (self.tempCommodityNo) {
          self.commodityNo = self.tempCommodityNo;
          self.tempCommodityNo = '';
          self.selectCommodity();
          self.getAccountList();
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    selectCommodity() {
      this.commodityList.forEach(v => {
        if (v.number == this.commodityNo) {
          this.commodity = v;
        }
      })
    },
    addAccount() {
      if (this.addAccountList.length < 5) {
        let account = {
          unit: [],
          role: '',
          ratio: '',
          accountType: ''
        }
        this.addAccountList.push(account);
      } else {
        this.$message.warning('最多添加5个分账人！')
      }
    },
    getUnitName(index) {
      let name = 'tree' + index;
      let nodes = this.$refs[name][0].getCheckedNodes();
      let unitName = [];
      let self = this;

      function getNodes(node) {
        if (node.label) {
          unitName.push(node.label);
          if (node.parent) {
            getNodes(node.parent);
          } else {
            unitName.reverse();
            self.addAccountList[index].unitName = unitName.join('>');
          }
        }
      }

      getNodes(nodes[0]);
    },
    deleteAccount(index) {
      this.addAccountList.splice(index, 1);
    },
    confirmAccount() {
      let ratio = 0;
      let unitNoList = [];
      let self = this;
      for (let i = 0; i < this.addAccountList.length; i++) {
        let v = this.addAccountList[i];
        if (v.unit.length == 0) {
          self.$message.warning('请选择分账人组织');
          return;
        }
        if (!v.role) {
          self.$message.warning('请输入分账人角色');
          return;
        }
        if (!v.accountType) {
          self.$message.warning('请选择分账人类型');
          return;
        }
        if (parseInt(v.ratio) < 0 || parseInt(v.ratio) > 100) {
          self.$message.warning('分账比例必须在0~100%之间');
          return;
        }
        unitNoList.push(v.unit[v.unit.length - 1]);
        ratio += parseInt(v.ratio);
      }
      unitNoList.sort();
      for (let i = 0; i < unitNoList.length - 1; i++) {
        if (unitNoList[i] == unitNoList[i + 1]) {
          this.$message.warning('分账人组织重复，请重新填写。');
          return;
        }
      }
      if (ratio != 100) {
        this.$message.warning('分账比例相加需等于100%');
        return;
      }
      this.accountList = JSON.parse(JSON.stringify(this.addAccountList));
      this.dialogVisible = false;
    },
    confirmEdit() {
      if (this.commodity.price <= 0) {
        this.$message.warning('此商品单价为0，无法分账');
        return;
      }
      let self = this;
      let reqList = [];
      this.accountList.forEach(v => {
        let item = {};
        item.unitNo = v.unit[v.unit.length - 1];
        item.role = v.role,
          item.ratio = v.ratio;
        item.userAccountNo = parseInt(Math.random() * 1000000 + '') + '';
        item.commodityNo = self.commodityNo;
        item.accountType = v.accountType;
        reqList.push(item);
      })
      let params = {
        reqList: JSON.stringify(reqList)
      };
      let url = '';
      if (this.type == 'add') {
        url = '/managementPlatform/fund/createDistributeRelation';
      } else if (this.type == 'edit') {
        url = '/managementPlatform/fund/updateDistributeRelation';
      }
      this.$http.post(url, this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        self.$message.success('操作成功！');
        self.cancel()
      }).catch(function (response) {
        console.log(response);
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  },
}
</script>
<style lang="scss" scoped>
.main-body {
  min-height: 50px;
}

.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .label {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }
}

.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
    width: 20%;
  }

  .value-label {
    float: left;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .info {
    float: left;
    padding-left: 30px;
    color: #777777;
    font-size: 14px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.bbn {
  border-bottom: none;
}

.dialog {
  .modal {
    .list {
      display: flex;

      .name {
        margin-left: 10px;
      }
    }
  }

  .icon {
    line-height: 33px;
    cursor: pointer;
    margin-left: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/subAccountDetailView.vue